import { createRouter, createWebHistory } from 'vue-router';
import UserLogin from './components/UserLogin.vue';
import UserRegister from './components/UserRegister.vue';
import PublicPage from './views/PublicPage.vue';
import MyAccountPage from './views/MyAccountPageV2.vue';
import ResetPassword from './views/ResetPassword.vue';
import CityPage from './views/CityPage.vue';
import DiscoverPage from './views/DiscoverPage.vue';
import JourneyJoinLandingPage from './views/JourneyJoinLandingPage.vue';
import EmergencyContactLandingPage from './views/EmergencyContactLandingPage.vue';
import LegalDocumentPage from './views/LegalDocumentPage.vue';
import DeleteAccountPage from './views/DeleteAccountPage.vue';
import AppPage from './views/AppPage.vue';

function consumeOAuthPayload() {
  if (typeof window === 'undefined') return null;

  const query = new URLSearchParams(window.location.search);
  const hash = window.location.hash.startsWith('#')
    ? new URLSearchParams(window.location.hash.slice(1))
    : new URLSearchParams();

  const token = hash.get('token') || query.get('token');
  if (!token) return null;

  return {
    token,
    redirect: sanitizePreLoginPath(
      hash.get('redirect') ||
      query.get('redirect') ||
      localStorage.getItem('preLoginRoute') ||
      '/my-account'
    ),
  };
}

function clearOAuthArtifacts() {
  if (typeof window === 'undefined') return;
  window.history.replaceState({}, document.title, window.location.pathname);
}


function sanitizePreLoginPath(path) {
  if (!path || typeof path !== 'string') return '/my-account';
  const first = path.trim().split(/\s+/)[0];
  return first.startsWith('/') ? first : '/my-account';
}
// Função de guarda de rota
function requireAuth(to, from, next) {
  if (localStorage.getItem('token')) {
    next(); // permite acessar a rota
  } else {
    localStorage.setItem('preLoginRoute', sanitizePreLoginPath(to.fullPath));
    next('/login'); // redireciona para a página de login
  }
}

const routes = [
  {
    path: '/',
    name: 'home',
    component: AppPage
  },
  {
    path: '/welcome',
    name: 'Welcome',
    component: PublicPage
  },
  {
    path: '/login',
    name: 'login',
    component: UserLogin
  },
  {
    path: '/register',
    name: 'register',
    component: UserRegister
  },
  {
    path: '/my-account',
    name: 'My Account',
    component: MyAccountPage,
    beforeEnter: requireAuth 
  },
  {
    path: '/reset-password',
    name: 'Reset Password',
    component: ResetPassword,
  },
  {
    path: '/city/:id',
    name: 'City',
    component: CityPage,
  },
  {
    path: '/discover',
    name: 'Discover',
    component: DiscoverPage,
  },
  {
    path: '/communities',
    redirect: '/discover',
  },
  {
    path: '/communities/:id',
    redirect: '/discover',
  },
  {
    path: '/join/:token',
    name: 'JourneyJoin',
    component: JourneyJoinLandingPage,
  },
  {
    path: '/emergency/:token',
    name: 'EmergencyContactJoin',
    component: EmergencyContactLandingPage,
  },
  {
    path: '/app',
    name: 'App',
    component: AppPage,
  },
  {
    path: '/privacy',
    name: 'PrivacyPolicy',
    component: LegalDocumentPage,
    props: { documentType: 'privacy' },
  },
  {
    path: '/terms',
    name: 'TermsOfUse',
    component: LegalDocumentPage,
    props: { documentType: 'terms' },
  },
  {
    path: '/delete-account',
    name: 'DeleteAccount',
    component: DeleteAccountPage,
  },
];
const router = createRouter({
  history: createWebHistory(),
  routes
});

// OAuth web: consumir token vindo por fragmento (preferido) ou query (legado)
// e limpar a URL imediatamente para não deixar JWT no histórico.
router.beforeEach((to, _from, next) => {
  const oauth = consumeOAuthPayload();
  if (oauth) {
    localStorage.setItem('token', oauth.token);
    localStorage.removeItem('preLoginRoute');
    clearOAuthArtifacts();
    next({ path: oauth.redirect, replace: true });
    return;
  }
  next();
});

router.afterEach(() => {
  const lang = localStorage.getItem('flipmemo_lang') || 'pt-BR';
  document.documentElement.lang = lang === 'en' ? 'en' : 'pt-BR';
});

export default router;
